// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Contacts_tabsContainer__34cM1","tab":"Contacts_tab__2jFSO","tabActive":"Contacts_tabActive__2mjNy","userCounter":"Contacts_userCounter__1oTGJ"};